import { useState, useEffect } from 'react';

// import LoadingSpinner from '../MySurveys/LoadingSpinner';
import './VideoTutorial.css';
import CircularProgress from '@material-ui/core/CircularProgress';

import classes from '../ShortlistComponent/AddProperty.module.css';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;

  return {
    width,
    height,
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

const VideoTutorial = (props) => {
  const [loading, stillLoading] = useState(true);
  const { height, width } = useWindowDimensions();
  const iframeClass = loading ? 'iframe' : 'iframe_afterload';
  const hideSpinner = () => {
    stillLoading(false);
  };

  return (
    <>
      {/* {console.log(width, height)} */}
      <div className="center">
        {loading && (
          <span className={classes.spinner}>
            <CircularProgress color="inherit" />
          </span>
        )}
        {/*   */}
        <iframe
          className={iframeClass}
          title="CBRE Workflow"
          src={props.url}
          width={width / 2}
          height={height - 200}
          onLoad={hideSpinner}
          allowFullScreen
          frameBorder="0"
        ></iframe>
      </div>
    </>
  );
};

export default VideoTutorial;
